// iframe環境で安全なCHATBOT_CONFIG取得
const getChatbotConfig = () => {
  try {
    // 現在のwindowでまず確認
    if (typeof window !== 'undefined' && window.CHATBOT_CONFIG) {
      return window.CHATBOT_CONFIG;
    }

    // iframe環境で親window確認
    if (typeof window !== 'undefined' &&
      window !== window.parent &&
      window.parent.CHATBOT_CONFIG) {
      return window.parent.CHATBOT_CONFIG;
    }

    // 最上位window確認
    if (typeof window !== 'undefined' &&
      window !== window.top &&
      window.top?.CHATBOT_CONFIG) {
      return window.top.CHATBOT_CONFIG;
    }

  } catch (error) {
    console.warn("CHATBOT_CONFIGアクセス中エラー:", error);
  }

  console.warn("CHATBOT_CONFIGが見つかりません");
  return null;
};

const config = getChatbotConfig();

export const oauth_key = config?.oauth_key || undefined;
export const oauth_domain = config?.oauth_domain || "resol";
// bottomとrightはCHATBOT_CONFIGで使用しなくなりました
// APIのchatbot_icon_position_x、chatbot_icon_position_yを使用します

// API エンドポイント安全作成
const createApiEndpoints = () => {
  if (!oauth_domain) {
    console.warn("oauth_domainが設定されていません");
    return {
      initialize: '',
      lead_acquisition: '',
      push_message: '',
      get_form_data: '',
    };
  }

  const apiDomain = import.meta.env.VITE_API_DOMAIN || 'onetouchai.net';
  const endpoints = {
    // NOTE: tenant-prefixed path (/{tenant}/api/...) is not preflight-safe in current infra.
    initialize: `https://${apiDomain}/api/initialize/`,
    lead_acquisition: `https://${apiDomain}/api/lead_acquisition/`,
    push_message: `https://${apiDomain}/api/push_message/`,
    get_form_data: `https://${apiDomain}/api/get_form_data/`,
  };
  return endpoints;
};

export const API_ENDPOINTS = createApiEndpoints();

export let session_id: string | null = "";

export function setSessionId(id: string | null) {
  session_id = id;
}


